import React, { useState } from 'react'
import { Box, Checkbox, Grid, IconButton, MenuItem, Select, TextField } from '@material-ui/core'
import { configurationTypes } from '@types'
import { Check, Close, Edit } from '@material-ui/icons'
import { useDispatch } from 'react-redux'
import { updateConfiguration } from '../state/configurationsSlice'

interface Props {
  label: string
  name: string
  value: any
  type: configurationTypes
  metadata: any
}

const ConfigurationBox: React.FC<Props> = ({ label, value, type, metadata, name }) => {
  const dispatch = useDispatch()
  const [isEditing, setEditing] = useState(false)
  const [actualValue, setValue] = useState(value)

  const cancelEdit = () => {
    setValue(value)
    setEditing(!isEditing)
  }

  const handleSave = () => {
    dispatch(updateConfiguration({ name, value: actualValue }))
    setEditing(false)
  }

  return (
    <Box border="1px solid #ff6900" borderRadius="1em" p="1em" height="100%" boxSizing="border-box">
      <Grid container>
        <Grid item xs={11}>
          <Box display="flex" alignItems="center" justifyContent="left">
            <Box px="1em">Nombre:</Box>
            <Box px="1em">{label}</Box>
          </Box>
          <Box display="flex" alignItems="center" justifyContent="left" mt="1em">
            <Box px="1em">Valor:</Box>
            <Box px="1em">
              {type === 'boolean' ? (
                <Checkbox
                  checked={actualValue}
                  color="primary"
                  disabled={!isEditing}
                  onChange={e => setValue(e.target.checked)}
                />
              ) : metadata?.options ? (
                <Select
                  variant="outlined"
                  value={actualValue}
                  disabled={!isEditing}
                  onChange={e => setValue(e.target.value)}
                >
                  {metadata.options.map((option: any) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </Select>
              ) : (
                <TextField
                  variant="outlined"
                  margin="normal"
                  value={actualValue}
                  disabled={!isEditing}
                  onChange={e => setValue(e.target.value)}
                />
              )}
            </Box>
          </Box>
        </Grid>
        <Grid item xs={1}>
          {!isEditing ? (
            <IconButton
              style={{
                color: '#ff6900',
                width: '8px',
                height: '10px'
              }}
              onClick={() => setEditing(!isEditing)}
            >
              <Edit style={{ width: '20px' }} />
            </IconButton>
          ) : (
            <>
              <IconButton onClick={handleSave}>
                <Check style={{ width: '20px' }} />
              </IconButton>
              <IconButton onClick={cancelEdit}>
                <Close style={{ width: '20px' }} />
              </IconButton>
            </>
          )}
        </Grid>
      </Grid>
    </Box>
  )
}

export default ConfigurationBox
